/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_TitleInputs */

const cs_sreality_title = /** @type {(inputs: Sreality_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sreality`)
};

const en_sreality_title = /** @type {(inputs: Sreality_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sreality`)
};

/**
* | output |
* | --- |
* | "Sreality" |
*
* @param {Sreality_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_title = /** @type {((inputs?: Sreality_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_title(inputs)
	return cs_sreality_title(inputs)
});